function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32 150L53.7 11.4C54 9.20004 56.1 7.70003 58.3 8.10003C59.5 8.30003 60.6 9.10003 61.2 10.2L83.6 52L92.5 35C93.5 33 95.9 32.3 97.9 33.3C98.6 33.7 99.2 34.3 99.6 35L160 150H32Z",
  fill: "#FFA000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M106.9 96L83.6 51.9L32 150L106.9 96Z",
  fill: "#F57C00"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M160 150L143.4 47.3C143 45.1 141 43.7 138.8 44C138 44.1 137.2 44.5 136.6 45.1L32 150L89.9 182.5C93.5 184.5 98 184.5 101.6 182.5L160 150Z",
  fill: "#FFCA28"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M143.5 47.4C143.1 45.2 141.1 43.8 138.9 44.1C138.1 44.2 137.3 44.6 136.7 45.2L115.9 66L99.5999 34.9C98.5999 32.9 96.1999 32.2 94.1999 33.2C93.4999 33.6 92.8999 34.2 92.4999 34.9L83.5999 51.9L61.1999 10.1C60.1999 8.19998 57.6999 7.39998 55.7999 8.49998C54.6999 9.09998 53.8999 10.2 53.6999 11.4L31.9999 150H31.8999L31.9999 150.1L32.5999 150.4L115.9 67L136.7 46.2C138.3 44.6 140.8 44.6 142.4 46.2C143 46.8 143.4 47.5 143.5 48.4L159.9 150.1L160.1 150L143.5 47.4ZM32.1999 149.8L53.6999 12.4C53.9999 10.2 56.0999 8.69998 58.2999 9.09998C59.4999 9.29998 60.5999 10.1 61.1999 11.2L83.5999 53L92.4999 36C93.4999 34 95.8999 33.3 97.8999 34.3C98.5999 34.7 99.1999 35.3 99.5999 36L115.6 66.4L32.1999 149.8Z",
  fill: "white",
  fillOpacity: 0.2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.2,
  d: "M101.6 181.5C98 183.5 93.5 183.5 89.9 181.5L32.1 149.1L32 150L89.9 182.5C93.5 184.5 98 184.5 101.6 182.5L160 150L159.9 149.1L101.6 181.5Z",
  fill: "#A52714"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M143.5 47.4C143.1 45.2 141.1 43.8 138.9 44.1C138.1 44.2 137.3 44.6 136.7 45.2L115.9 66L99.6 34.9C98.6 32.9 96.2 32.2 94.2 33.2C93.5 33.6 92.9 34.2 92.5 34.9L83.6 51.9L61.2 10.1C60.2 8.19998 57.7 7.39998 55.8 8.49998C54.7 9.09998 53.9 10.2 53.7 11.4L32 150L89.9 182.5C93.5 184.5 98 184.5 101.6 182.5L160 150L143.5 47.4Z",
  fill: "url(#paint0_linear)"
});

var _ref8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 28.5538,
  y1: 38.9726,
  x2: 162.241,
  y2: 172.66,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9f710f9b.svg";
export { ForwardRef as ReactComponent };